export default __webpack_public_path__ + "static/media/home-fin-made-simple.74cb155f.svg";